import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';
import { getIsMESEnabled } from './getIsMESEnabled';

/** Returns true when labor tickets are enabled (always true for MES-enabled machines). */
const getIsLaborTicketEnabled = createSelector(
  [getCompanySettings, getIsMESEnabled],
  (companySettings, mesEnabled) => {
    if (mesEnabled) return true;
    return companySettings?.laborTicketEnabled ?? false;
  }
);

export { getIsLaborTicketEnabled };
